import { render, staticRenderFns } from "./ivst.vue?vue&type=template&id=6363c8dc&scoped=true"
import script from "./ivst.vue?vue&type=script&lang=js"
export * from "./ivst.vue?vue&type=script&lang=js"
import style0 from "./ivst.vue?vue&type=style&index=0&id=6363c8dc&prod&scoped=true&lang=css"
import style1 from "./ivst.vue?vue&type=style&index=1&id=6363c8dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6363c8dc",
  null
  
)

export default component.exports